import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import CheckboxTree from 'react-checkbox-tree';
import Alert from '../common/Alert';
import Loader from '../Loader';

import { MetadataService } from './../../service/metadata.service';
import { CompanyService } from './../../service/company.service';
import { ApplicationService } from './../../service/application.service';

import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';
import '../../../node_modules/react-checkbox-tree/lib/react-checkbox-tree.css';

const AppApproval = (params) => {
    const companyService = new CompanyService();
    const metadataService = new MetadataService();
    const applicationService = new ApplicationService();

    const [data, setData] = useState([]);
    const [appId, SetAppId] = useState(0);
    const [metadata, setMetadata] = useState([]);
    const [bsUnitExist, setBsUnitExist] = useState(false);
    const [application, setApplication] = useState({});
    const [applications, setApplications] = useState([]);
    const [users, SetUsers] = useState([]);
    const [approver, SetApprover] = useState([]);
    const [globalApprovers, setGlobalApprovers] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [businessUnit, setBusinessUnit] = useState([]);

    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [invokeCallBack, setInvokeCallBack] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);

    const [regions, setRegion] = useState([]);
    const [checkedRegionCountry, setCheckedRegionCountry] = React.useState([]);
    const [expandedRegionCountry, setExpandedRegionCountry] = React.useState([]);

    const appScreenWidth = ((params.showCloseButton === "true") ? 'appScreenWidth' : 'noAppScreenWidth');

    useEffect(() => {
        const fetchData = async () => {
            setPageLoading(true);
            try {
                SetAppId(params.id ? params.id : 0);

                const result = await applicationService.getApplications();
                let dataApp = result.data.map(function (a) {
                    return { value: a.id, label: (a.name) };
                });
                setApplications(dataApp);

                if (params.id !== 0) {
                    loadApplicationData(params.id, dataApp);
                }

            } catch (error) {
                console.error(error);
            }

            setPageLoading(false);
        };

        fetchData();
    }, []);

    const loadApplicationData = async (aid, apps) => {
        setPageLoading(true);

        SetAppId(aid ? aid : 0);

        if (!apps) {
            apps = applications;
        }

        const app = apps.find((x) => x.value === aid);
        setApplication(app);

        const rsApprover = await applicationService.getApplicationglobalApprovers(aid);
        let dataUser = rsApprover.data.users.map(function (a) {
            return { value: a.id, label: (a.firstName + " " + a.lastName) };
        });
        SetUsers(dataUser);

        let dataApprover = rsApprover.data.globalApprovers.map(function (a) {
            return { value: a.id, label: (a.firstName + " " + a.lastName) };
        });
        setGlobalApprovers(dataApprover);

        let dataMetadata = rsApprover.data.metadatas.map(function (a) {
            return { value: a.id, label: a.name };
        });
        setMetadata(dataMetadata);

        let isBsUnitExist = rsApprover.data.metadatas.some(x => x.id === 4);
        setBsUnitExist(isBsUnitExist);

        const countryRegionResult = await metadataService.getRegionCountries(aid);
        setRegion(countryRegionResult.data);

        if (countryRegionResult !== undefined && countryRegionResult.data !== undefined) {
            const expandedRegions = countryRegionResult.data.map((x) => { return x.value });
            setExpandedRegionCountry(expandedRegions);
        }

        const companyResult = await companyService.getCompanyOnly();
        //const companyResult = await companyService.getapplicationcompanyonly(aid);
        const companyData = companyResult.data.map((x) => {
            return { value: x.id, label: x.name, checked: false, expanded: true };
        });
        setCompanies(companyData);

        if (isBsUnitExist === true) {
            const businessUnitResult = await metadataService.getBusinessUnit();
            const businessUnitData = businessUnitResult.data.map((x) => {
                return { value: x.id, label: x.name, checked: false, expanded: true };
            });
            setBusinessUnit(businessUnitData);
        }

        const apResult = await applicationService.getApprovaldetails(aid)
        setData(apResult.data);

        setPageLoading(false);
    }

    
    const onCheckRegionCountry = (ckd) => {
        setCheckedRegionCountry(ckd);
    };

    const onExpandRegionCountry = (expanded) => {
        setExpandedRegionCountry(expanded);
    };

    const checkTreeList = (listData, value, tag) => {
        const updatedList = listData.map(item => {
            let isChecked = false;
            if (value.includes(item.value.toString())) {
                isChecked = true;
            }
            return { ...item, checked: isChecked };
        });

        tag === "companies" ? setCompanies(updatedList) :
            tag === "businessUnit" ? setBusinessUnit(updatedList) :
                console.log("No tag found to reset");
    };

    const searchApprovers = async () => {
        setPageLoading(true);
        const countryIds = checkedRegionCountry.filter((x) => (x.indexOf('r-') === -1));
        const companyIds = companies.filter((x) => (x.checked === true)).map((x) => { return x.value });
        const bsUnitIds = bsUnitExist ? businessUnit.filter((x) => (x.checked === true)).map((x) => { return x.value }) : [];

        const resApprovers = await applicationService.searchApprovers(appId, companyIds, countryIds, bsUnitIds, [])
        if (resApprovers.data !== undefined && resApprovers.data !== null) {
            const appResultData = resApprovers.data.map((x) => { return { value: x.id, label: x.name } });
            SetApprover(appResultData);
        }
        setPageLoading(false);
    };

    const checkValidation = async (countryIds, companyIds, bsUnitIds) => {
        //if (!countryIds || countryIds.length === 0) {
        //    return {status: false, message: "No country selected for this approver setup"}
        //}
        //else if (!companyIds || companyIds.length === 0) {
        //    return { status: false, message: "No company selected for this approver setup" }
        //}
        //else if (bsUnitExist && (!bsUnitIds || bsUnitIds.length === 0)) {
        //    return { status: false, message: "No business unit selected for this approver setup" }
        //}
        //else if (!approver || approver.length === 0) {
        //    return { status: false, message: "No approver selected for this approver setup" }
        //}

        if ((!countryIds || countryIds.length === 0) && (!companyIds || companyIds.length === 0)) {
            return { status: false, message: "No combination is selected for this approver setup" }
        }
        else if (!approver || approver.length === 0) {
            return { status: false, message: "No approver selected for this approver setup" }
        }

        return { status: true, message: "Ok" }
    };

    const clearAll = () => {        
        setCheckedRegionCountry([]);

        const companyUnchecked = companies.map(item => {
            let isChecked = false;
            return { ...item, checked: isChecked };
        });
        setCompanies(companyUnchecked);

        const buUnchecked = businessUnit.map(item => {
            let isChecked = false;
            return { ...item, checked: isChecked };
        });
        setBusinessUnit(buUnchecked);

        SetApprover([]);
    };

    const saveApprovers = async () => {
        setPageLoading(true);

        setInvokeCallBack(false);

        const countryIds = checkedRegionCountry.filter((x) => (x.indexOf('r-') === -1));
        const companyIds = companies.filter((x) => (x.checked === true)).map((x) => { return x.value });
        const bsUnitIds = bsUnitExist ? businessUnit.filter((x) => (x.checked === true)).map((x) => { return x.value }) : [];

        const validationResult = await checkValidation(countryIds, companyIds, bsUnitIds);
        if (validationResult.status === true) {

            const approverIds = approver.map((x) => { return x.value });
            const globalApproverIds = globalApprovers.map((x) => { return x.value });

            let saveResult = await applicationService.saveApprover(appId, globalApproverIds, approverIds, companyIds, countryIds, bsUnitIds, []);
            if (saveResult.status === 200) {
                setAlertMessage("Application approver has been saved successfully");
                setInvokeCallBack(true);
                alertOn(true);
            }
            else {
                setAlertMessage("Something wrong! approver setup was unsuccessful");
                alertOn(true);
            }
        }
        else {
            setAlertMessage(validationResult.message);
            alertOn(true);
        }

        setPageLoading(false);
    };

    const alertOff = async () => {
        setIsAlert(false);

        if (invokeCallBack === true) {
            //params.callBack();
            const apDataResult = await applicationService.getApprovaldetails(appId)
            setData(apDataResult.data);
            clearAll();
        }
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <div className={appScreenWidth}>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            {pageLoading && <Loader />}

            <div className="card">
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Application Approval
                </h5>
                <div className="card-body" style={{ height: "75vh" }}>
                    <div className="ag-theme-alpine" style={{ maxHeight: "70vh", marginRight: "-15px", overflowY: "auto" }}>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Application</label>
                                        <Select value={application} options={applications} onChange={(e) => loadApplicationData(e.value)} />
                                    </div>
                                </div>

                                <div className="col-md-7">
                                    <div className="form-group">
                                        <label>Global Approver</label>
                                        <Select value={globalApprovers} options={users} isMulti onChange={(e) => setGlobalApprovers(e)} />
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="form-group" >
                                        <button style={{ marginTop: "25px", float: "right" }} onClick={searchApprovers} title="Search to find approver by the selected combination" className="btn btn-secondary"><i className="fas fa-search"></i>Search</button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className={bsUnitExist ? "col-md-4" : "col-md-6"}>
                                    <div className="divApprovalBox">
                                        <h6 style={{ marginLeft: "15px" }} >Country</h6>
                                        <div style={{ height: "200px", overflowY: "auto" }}>

                                            <CheckboxTree
                                                nodes={regions}
                                                checked={checkedRegionCountry}
                                                expanded={expandedRegionCountry}
                                                onCheck={onCheckRegionCountry}
                                                onExpand={onExpandRegionCountry}
                                                showCheckbox={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={bsUnitExist ? "col-md-4" : "col-md-6"}>
                                    <div className="divApprovalBox">
                                        <h6 style={{ marginLeft: "15px" }} >Company</h6>
                                        <div style={{ height: "200px", overflowY: "auto" }}>
                                            <CheckboxTree
                                                nodes={companies}
                                                checked={companies.filter((n) => n.checked).map((n) => n.value)}
                                                expanded={companies.filter((n) => n.expanded).map((n) => n.value)}
                                                onCheck={(x) => { checkTreeList(companies, x, "companies") }}
                                                showCheckbox={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {bsUnitExist ?
                                    <div className="col-md-4">
                                        <div className="divApprovalBox">
                                            <h6 style={{ marginLeft: "15px" }} >Business Unit</h6>
                                            <div style={{ height: "200px", overflowY: "auto" }}>
                                                <CheckboxTree
                                                    nodes={businessUnit}
                                                    checked={businessUnit.filter((n) => n.checked).map((n) => n.value)}
                                                    expanded={businessUnit.filter((n) => n.expanded).map((n) => n.value)}
                                                    onCheck={(x) => { checkTreeList(businessUnit, x, "businessUnit") }}
                                                    showCheckbox={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                            </div>
                            <div className="row" style={{ marginTop: "15px" }}>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Approver</label>
                                        <Select value={approver} options={users} isMulti onChange={(e) => SetApprover(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div style={{ padding: "15px" }}>
                                    {
                                        (data && data.length > 0) ?
                                            <table className='table table-striped' aria-labelledby="tabelLabel">
                                                <thead>
                                                    <tr style={{ backgroundColor: "lightgray" }}>
                                                        <th>Id</th>
                                                        <th>Combinations</th>
                                                        <th>Approvers</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.map(x =>
                                                        <tr key={x.id}>
                                                            <td>{x.id}</td>
                                                            <td>{x.combinations}</td>
                                                            <td>{x.approvers}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            : <h3 style={{ textAlign: 'center' }}></h3>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button className="btn btn-secondary" style={{ marginRight: "5px" }} onClick={saveApprovers}>Save</button>
                        {
                            (params.showCloseButton === "true") ?
                                <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                                : ""
                        }
                    </div>                    
                </div>
            </div>
        </div>
    );
};

export default AppApproval;